import React, { useEffect, useState } from "react";
import { Alert } from "antd";

interface WidePageHintProps {
  /** 自定义提示文案;缺省为通用宽表格提示。 */
  message?: string;
}

// WidePageHint:移动端访问宽表格/画布等需要横向空间的页面时,顶部给出"建议桌面端查看"横幅。
// 自带视口检测,仅在窄屏(<768px)渲染;桌面端返回 null,不占空间(U12 移动端走查)。
const WidePageHint: React.FC<WidePageHintProps> = ({ message }) => {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" && window.innerWidth < 768
  );

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  if (!isMobile) return null;

  return (
    <Alert
      type="info"
      showIcon
      banner
      style={{ marginBottom: 12 }}
      message={message || "本页包含宽表格,建议在桌面端查看以获得完整体验。"}
    />
  );
};

export default WidePageHint;
